var _rect, _rect2, _path, _path2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _g3, _path3, _path4, _path5, _g4, _path6, _path7, _circle, _circle2, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcknowledge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 200,
    viewBox: "0 0 228 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 200,
    height: 200,
    rx: 100,
    fill: "#17B7FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2675_372122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 200
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2675_372122)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8881 205.777C9.88566 224.521 -9.07623 240.521 -9.07623 240.521L49.1831 246.537C49.1831 246.537 72.2179 197.205 79.9404 187.893C87.6628 178.582 93.5481 178.125 106.418 172.174C119.289 166.223 145.77 114.026 147.2 111.777C148.63 109.528 150.693 105.506 149.737 104.049C148.782 102.593 146.455 103.264 142.967 106.25C139.478 109.236 129.685 119.743 129.685 119.743L126.794 117.315C126.794 117.315 142.289 91.694 143.603 89.0386C144.918 86.3832 146.327 83.4391 144.546 81.4504C142.765 79.4618 140.294 81.8225 138.261 83.0726C136.227 84.3227 124.932 96.0333 124.932 96.0333C124.932 96.0333 117.995 90.2068 121.184 89.9278C124.374 89.6488 136.305 72.7448 138.645 69.0999C140.985 65.4549 142.871 62.2967 140.512 59.8225C138.153 57.3483 134.272 61.9767 130.738 64.4305C127.203 66.8842 114.546 81.3946 114.546 81.3946L72.6007 128.49C72.6007 128.49 67.6877 105.276 64.2863 100.803C60.885 96.3305 53.236 96.9447 53.236 96.9447C53.236 96.9447 55.2751 102.763 56.2932 107.4C57.4254 112.556 57.9338 116.484 58.7993 123.8C60.1872 135.531 52.5045 143.571 52.4354 149.018C52.3817 153.249 52.9664 164.693 49.6063 171.783C41.9194 188.003 41.8905 187.032 25.8881 205.777Z",
    fill: "#CD8B52"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2675_372122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -10,
    y: 59,
    width: 160,
    height: 188
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8881 205.777C9.88566 224.521 -9.07623 240.521 -9.07623 240.521L49.1831 246.537C49.1831 246.537 72.2179 197.205 79.9404 187.893C87.6628 178.582 93.5481 178.125 106.418 172.174C119.289 166.223 145.77 114.026 147.2 111.777C148.63 109.528 150.693 105.506 149.737 104.049C148.782 102.593 146.455 103.264 142.967 106.25C139.478 109.236 129.685 119.743 129.685 119.743L126.794 117.315C126.794 117.315 142.289 91.694 143.603 89.0386C144.918 86.3832 146.327 83.4391 144.546 81.4504C142.765 79.4618 140.294 81.8225 138.261 83.0726C136.227 84.3227 124.932 96.0333 124.932 96.0333C124.932 96.0333 117.995 90.2068 121.184 89.9278C124.374 89.6488 136.305 72.7448 138.645 69.0999C140.985 65.4549 142.871 62.2967 140.512 59.8225C138.153 57.3483 134.272 61.9767 130.738 64.4305C127.203 66.8842 114.546 81.3946 114.546 81.3946L72.6007 128.49C72.6007 128.49 67.6877 105.276 64.2863 100.803C60.885 96.3305 53.236 96.9447 53.236 96.9447C53.236 96.9447 55.2751 102.763 56.2932 107.4C57.4254 112.556 57.9338 116.484 58.7993 123.8C60.1872 135.531 52.5045 143.571 52.4354 149.018C52.3817 153.249 52.9664 164.693 49.6063 171.783C41.9194 188.003 41.8905 187.032 25.8881 205.777Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2675_372122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1585 239.321C25.1585 239.321 71.7524 188.569 79.4481 176.142C87.1437 163.715 78.7154 149.4 78.7154 149.4L111.954 76.2601L135.295 147.13L131.542 171.584L52.8137 239.053L25.1585 239.321Z",
    fill: "#CB793D"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7461,
    y: 21.7783,
    width: 71.0973,
    height: 137.76,
    rx: 5.46917,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2675_372122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 21,
    width: 72,
    height: 139
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7461,
    y: 21.7783,
    width: 71.0973,
    height: 137.76,
    rx: 5.46917,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2675_372122)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4805,
    y: 24.5154,
    width: 64.7168,
    height: 132.286,
    rx: 3.64611,
    fill: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2675_372122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 24,
    width: 66,
    height: 133
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4805,
    y: 24.5154,
    width: 64.7168,
    height: 132.286,
    rx: 3.64611,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2675_372122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.4805,
    y: 24.5154,
    width: 64.7168,
    height: 132.286,
    fill: "#031D43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5039,
    y: 60,
    width: 47,
    height: 38,
    rx: 4,
    fill: "#D2EFF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5039 64C76.5039 61.7909 78.2948 60 80.5039 60H119.504C121.713 60 123.504 61.7909 123.504 64V94C123.504 96.2091 121.713 98 119.504 98H80.5039C78.2948 98 76.5039 96.2091 76.5039 94V64Z",
    fill: "#89D0FE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5039 93L100.504 74L123.504 93V94C123.504 96.2091 121.713 98 119.504 98H80.5039C78.2948 98 76.5039 96.2091 76.5039 94V93Z",
    fill: "#89D0FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.504 64L101.857 84.7055C101.096 85.4338 99.9001 85.4465 99.1234 84.7345L76.5039 64L123.504 64Z",
    fill: "#031D43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5039 64C76.5039 61.7909 78.2948 60 80.5039 60H119.504C121.713 60 123.504 61.7909 123.504 64L101.751 81.9699C101.024 82.5707 99.9754 82.5816 99.2357 81.996L76.5039 64Z",
    fill: "#D2EFF9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 75.6836,
    y: 29.0769,
    width: 16.4071,
    height: 2.73695,
    rx: 1.36729,
    fill: "#89D0FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.049 221.294C134.049 221.294 181.437 200.407 178.579 190.629L177.746 187.802C175.311 179.637 173.43 174.332 170.933 171.911C168.159 169.221 164.978 170.317 161.423 170.07C157.947 169.828 158.069 162.669 150.859 165.483L150.356 165.691C142.635 169.041 142.776 163.012 138.195 164.082C133.678 165.136 131.458 171.251 130.706 170.086C123.755 159.329 123.557 111.212 116.325 112.514C109.203 113.796 111.481 133.708 112.192 148.943L112.224 149.643C112.671 159.855 112.668 172.557 112.215 187.75C108.62 182.271 105.375 178.448 102.479 176.282C98.1364 173.032 90.9419 173.569 90.4531 175.617C95.0093 181.903 110.049 210.373 134.049 221.294Z",
    fill: "#041E42"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 94.8242,
    y: 151.328,
    width: 10.0265,
    height: 0.912318,
    rx: 0.455764,
    fill: "#E8E8E8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6053 95.8648C52.3268 94.9136 53.3865 94.1324 54.2127 94.6798C54.4348 94.8269 54.5935 95.052 54.6575 95.3105L56.4846 102.689L56.9842 104.312C57.0236 104.44 57.0345 104.575 57.0159 104.708C56.8795 105.683 55.5097 105.783 55.233 104.838L52.6053 95.8648Z",
    fill: "#FDE5BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.248 303.148L187.649 298.209C187.649 298.209 170.776 256.248 169.441 241.934C168.106 227.62 166.848 224.609 170.027 214.929C173.207 205.248 179.404 199.335 176.525 189.51C173.646 179.685 171.617 173.405 168.825 170.701C166.033 167.997 162.834 169.097 159.258 168.847C155.681 168.597 155.888 161.08 148.122 164.443C140.357 167.806 140.496 161.748 135.888 162.821C131.345 163.879 129.115 170.02 128.357 168.85C121.361 158.04 121.14 109.697 113.866 111.002C106.591 112.307 109.075 132.913 109.757 148.303C110.439 163.693 109.765 186.589 109.765 186.589C109.765 186.589 104.336 178.329 99.9661 175.062C95.5958 171.795 88.3587 172.331 87.868 174.389C92.454 180.707 95.0988 187.865 99.0768 194.908C103.055 201.95 99.0634 203.139 104.227 209.984C107.502 214.325 110.894 214.702 116.722 221.366C120.91 226.153 130.553 244.148 133.687 252.93C140.858 273.019 141.248 303.148 141.248 303.148Z",
    fill: "#CD8B52"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2675_372122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 110,
    width: 101,
    height: 194
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.248 303.148L187.649 298.209C187.649 298.209 170.776 256.248 169.441 241.934C168.106 227.62 166.848 224.609 170.027 214.929C173.207 205.248 179.404 199.335 176.525 189.51C173.646 179.685 171.617 173.405 168.825 170.701C166.033 167.997 162.834 169.097 159.258 168.847C155.681 168.597 155.888 161.08 148.122 164.443C140.357 167.806 140.496 161.748 135.888 162.821C131.345 163.879 129.115 170.02 128.357 168.85C121.361 158.04 121.14 109.697 113.866 111.002C106.591 112.307 109.075 132.913 109.757 148.303C110.439 163.693 109.765 186.589 109.765 186.589C109.765 186.589 104.336 178.329 99.9661 175.062C95.5958 171.795 88.3587 172.331 87.868 174.389C92.454 180.707 95.0988 187.865 99.0768 194.908C103.055 201.95 99.0634 203.139 104.227 209.984C107.502 214.325 110.894 214.702 116.722 221.366C120.91 226.153 130.553 244.148 133.687 252.93C140.858 273.019 141.248 303.148 141.248 303.148Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2675_372122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7593 212.038L74.1835 171.55L88.2636 163.608L104.219 176.996L109.765 186.589C109.765 186.589 109.612 198.402 113.209 210.47C116.806 222.538 124.887 236.322 124.887 236.322L79.7593 212.038Z",
    fill: "#CB793D"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5685 173.225C85.9805 172.283 86.8103 171.096 87.8965 171.326C88.2535 171.401 88.5602 171.627 88.7373 171.946L92.2583 178.287L93.1109 179.602C93.2132 179.76 93.2727 179.942 93.2836 180.13C93.349 181.252 91.8745 181.721 91.279 180.768L86.5685 173.225Z",
    fill: "#FDE5BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.983 118.435C111.501 118.87 112.119 119.651 113.488 119.659C114.857 119.667 115.821 118.982 116.254 118.467C116.686 117.951 116.702 116.67 116.637 114.559C116.571 112.447 116.52 110.785 116.002 110.351C115.483 109.916 114.868 109.135 113.497 109.127C112.126 109.119 111.163 109.804 110.731 110.319C110.298 110.835 110.271 111.755 110.34 113.986C110.41 116.216 110.465 118.001 110.983 118.435Z",
    fill: "#FDE5BC"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 43,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 43,
    r: 43,
    fill: "#E8E8E8",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.348 43.7656C208.251 44.0015 208.106 44.2225 207.914 44.4142L193.914 58.4142L193.637 58.6456C192.858 59.1856 191.78 59.1085 191.086 58.4142L190.854 58.1372C190.314 57.3577 190.392 56.2801 191.086 55.5858L201.672 45H162.5C161.395 45 160.5 44.1046 160.5 43C160.5 42.0182 161.208 41.2016 162.14 41.0322L162.5 41H201.672L191.086 30.4142L190.854 30.1372C190.314 29.3577 190.392 28.2801 191.086 27.5858C191.867 26.8047 193.133 26.8047 193.914 27.5858L207.914 41.5858C207.999 41.6705 208.076 41.7627 208.144 41.8614L208.146 41.8628C208.227 41.9808 208.295 42.1057 208.348 42.2351C208.438 42.4527 208.488 42.683 208.498 42.9147C208.499 42.9431 208.5 42.9716 208.5 43C208.5 43.2712 208.446 43.5298 208.348 43.7656Z",
    fill: "#031D43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcknowledge);
export default __webpack_public_path__ + "static/media/acknowledge.1341c020bec00fed20503f504047c109.svg";
export { ForwardRef as ReactComponent };